module.exports = __webpack_public_path__ + "img/9788989456209.8b6dea0a.jpg";